"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInfoBoxDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
function parseInfoBoxDescription(description, language = i18n_1.Language.English) {
    try {
        const parsedDescription = JSON.parse(description);
        return parsedDescription.map((item, index) => {
            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(language === i18n_1.Language.English || item.name !== 'Quick Facts') && ((0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'parseInfoBoxDescription_Title', children: item.name })), (0, jsx_runtime_1.jsx)(Paragraph, { "data-e2e": 'parseInfoBoxDescription_Paragraph', children: item.text })] }, index));
        });
    }
    catch (e) {
        return description.split(/(\r|\n)+/).filter(item => item.trim());
    }
}
exports.parseInfoBoxDescription = parseInfoBoxDescription;
const Title = styled_components_1.default.div `
  margin: 12px 0 5px;

  text-align: left;
  text-transform: uppercase;

  user-select: text;

  &:first-child {
    margin-top: 0;
  }
`;
const Paragraph = styled_components_1.default.div `
  margin: 5px 0 0 0;

  white-space: pre-line;
  text-align: justify;

  user-select: text;
`;
